import { render } from "./Tipstishi.vue?vue&type=template&id=4595b448&scoped=true&ts=true"
import script from "./Tipstishi.vue?vue&type=script&lang=ts"
export * from "./Tipstishi.vue?vue&type=script&lang=ts"

import "./Tipstishi.vue?vue&type=style&index=0&id=4595b448&scoped=true&lang=css"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4595b448"]])

export default __exports__